// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class TextMessage extends TrackingModel {
	public TextMessageId: number = 0;
	public GatewayProviderProviderTypeId?: number;
	public FromNumber: string = "";
	public ToNumber: string = "";
	public Body: string = "";
	public SendAfterUTC?: Date;
	public SentOnUTC?: Date;
}